<template>
    <div id="data-list-team-view" class="data-list-container" v-can="'settings_team.access'">
        <ds-table ref="table" :data="teams" :heads="headNotGroup" expand search>
            <template v-slot:header class="header-table">
                <div class="flex items-center">
                    <vs-button v-can="'settings_team.create'"
                               @click="callPopup('createTeam', $t('buttons.Create_team'))"
                               class="mr-4 cteate-team__btn" color="primary"
                               type="border"
                               v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                    >
                        {{ $t('buttons.Create_team') }}
                    </vs-button>
                </div>
            </template>

            <template v-slot:name="{name}">
                <div class="flex items-center">
                    <div class="ml-1 mr-4 team_id">{{ name.internalId }}</div>
                    <div>
                        <p class="product-name font-medium truncate">{{ name.name || name.id }}</p>
                        <div class="flex items-center">
                            <div class="text-xs" style="color: #bfbfbf;">Secret key</div>
                            <vs-icon
                                class="ml-2 cursor-pointer"
                                color="primary"
                                v-tooltip="$t('tooltip.Copy')"
                                @click.stop.prevent="copy(name.secret_key)"
                                v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:users_list="{users_list}">
                <vs-chip v-tooltip.left="users_list.usersList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-users', 'fi-rr-users')"/>
                    <span>{{ users_list.usersLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:integrations="{integrations}">
                <vs-chip v-tooltip.left="integrations.integrations.join('<br>')">
                    <vs-avatar class="cursor-default" color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-git-branch', 'fi-rr-code-branch')"/>
                    <span>{{ integrations.integrationsLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:is_internal_team="{is_internal_team}">
                <div class="flex justify-center">
                    <div class="flex justify-center">
                        <vs-icon
                            v-if="!!is_internal_team.is_internal"
                            color="success"
                            v-bind="$iconData('icon-check', 'fi-rr-check')"
                        />

                        <vs-icon
                            v-else
                            color="danger"
                            v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                        />
                    </div>
                </div>
            </template>

            <template v-slot:hot="{hot}">
                <div class="flex justify-center">
                    <vs-icon
                        v-if="!!hot.is_hot"
                        color="success"
                        v-bind="$iconData('icon-check', 'fi-rr-check')"
                    />

                    <vs-icon
                        v-else
                        color="danger"
                        v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                    />
                </div>
            </template>

            <template v-slot:should_skip_double="{should_skip_double}">
                <div class="flex justify-center">
                    <vs-icon
                        v-if="!!should_skip_double.should_skip_double"
                        color="success"
                        v-bind="$iconData('icon-check', 'fi-rr-check')"
                    />

                    <vs-icon
                        v-else
                        color="danger"
                        v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                    />
                </div>
            </template>

            <template v-slot:autologin="{autologin}">
                <div class="flex justify-center">
                    <vs-icon
                        v-if="!!autologin.is_hide_autologin"
                        color="success"
                        v-bind="$iconData('icon-check', 'fi-rr-check')"
                    />

                    <vs-icon
                        v-else
                        color="danger"
                        v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                    />
                </div>
            </template>

            <template v-slot:active="{active}">
                <div>
                    <vs-switch
                        v-can="'settings_team.destroy'"
                        color="success"
                        v-model="active.is_active"
                        @click.prevent.stop="changeTeamStatus($event, active)"
                        icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"
                    />
                    <vs-switch v-can:show="'settings_team.destroy'" color="success"
                               v-model="active.is_active" disabled icon-pack="feather" vs-icon-off="icon-x"
                               vs-icon-on="icon-check"/>
                </div>
            </template>

            <template v-slot:actions="{actions}">
                <div class="flex items-center h-full">
                    <vs-button v-can="'settings_team.create_integration'"
                               @click.stop="callPopup('createTeamIntegration', $t('buttons.Add_integration'), {nameProperty: 'ids', data: {id: actions.id, users: actions.users}}, true)"
                               v-tooltip="$t('buttons.Add_integration')" radius color="primary" type="flat"
                               v-bind="$iconData('icon-plus', 'fi-rr-plus')"></vs-button>
                    <vs-button v-can:show="'settings_advertiser.create'" disabled
                               v-tooltip="$t('buttons.Add_integration')" radius color="primary" type="flat"
                               v-bind="$iconData('icon-plus', 'fi-rr-plus')"></vs-button>

                    <vs-button
                        v-can="'settings_team.update'"
                        @click.stop="callPopup('editTeam', $t('modals.Edit_team'), {nameProperty: 'ids', data: actions})"
                        radius
                        v-tooltip="$t('modals.Edit_team')"
                        color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"></vs-button>
                    <vs-button v-can:show="'settings_team.update'" disabled radius color="primary"
                               type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"></vs-button>
                    <vs-button v-can="'settings_advertiser.create'"
                               @click.stop="callPopup('copyIntegrations', $t('modals.Сopy_integration'), {nameProperty: 'data', data: actions})"
                               radius
                               v-tooltip="$t('modals.Сopy_integration')" color="primary" type="flat"
                               v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"></vs-button>
                    <vs-button v-can:show="'settings_advertiser.create'" disabled radius color="primary"
                               type="flat" v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"></vs-button>
                </div>
            </template>

            <template v-if="!!userPermissions.settings_advertiser" v-slot:expand="{expand}">
                <team-details :details="expand.users" :team-id="expand.id" class="team-details w-full"></team-details>
            </template>
        </ds-table>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import EventBus from '@/store/eventBus'
import TeamDetails from '@/views/settings/teams/TeamDetails.vue'
import ErrorHandler from '@/utils/errorHandler'
import TeamsGroupedByAdvertiser from './GroupedByAdvertiser/TeamsGroupedByAdvertiser'
import send from '@/utils/fetch'

import {sorting} from '@/utils/mixins'
import {copy, getSystemSetting} from '@/utils/utils'

export default {
    components: {
        TeamDetails,
        TeamsGroupedByAdvertiser,
    },

    mixins: [sorting],

    data() {
        return {
            filterFields: [
                {name: 'global.Manager', type: 'select', key: 'manager', label: 'name', field: 'id'}
            ],
            headGroup: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Teams', key: 'teams', sortKey: 'teamsLength', value: 'teams', display: true},
                {name: 'permissions.statistic_falcon', key: 'falcon', sortKey: 'is_falcon', value: 'falcon', display: true},
            ],
            headNotGroup: [
                {name: 'global.id', key: 'internalId', sortKey: 'internalId', value: 'internalId', display: false},
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', headerPosition: 'start', display: true},
                {name: 'global.Users', key: 'users_list', sortKey: 'usersLength', value: 'users_list', headerPosition: 'center', display: getSystemSetting('teams_show_users')},
                {name: 'global.Integrations', key: 'integrations', sortKey: 'integrationsLength', headerPosition: 'center', value: 'integrations', display: getSystemSetting('teams_show_integrations')},
                {name: 'table.Is_internal_team', key: 'is_internal_team', sortKey: 'is_internal', headerPosition: 'center', value: 'is_internal_team', width: '120px', display: true, center: true},
                {name: 'table.isHot', key: 'isHot', sortKey: 'is_hot', value: 'hot', headerPosition: 'center', width: '130px', display: true, center: true},
                // {name: 'global.acceptDuplicates', key: 'should_skip_double', sortKey: 'should_skip_double', value: 'should_skip_double', display: true, center: true},
                {name: 'table.autologin', key: 'is_hide_autologin', sortKey: 'is_hide_autologin', headerPosition: 'center', value: 'autologin',  width: '130px', display: true, center: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'active', headerPosition: 'center', width: '80px', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', headerPosition: 'end', width: '130px', display: true},
            ],
            isGroupByAdvertiser: false,
            groupByAdvertiser: [],
            itemsPerPage: 10,
            isMounted: false,
            currentIndex: null,
            currentArrIndex: null,
            loadingEl: null,
            nameTeamForSearch: '',
            teamsList: [],
            teamsListFilter: [],
        }
    },
    computed: {
        ...mapGetters(['teams', 'userPermissions']),

        currentPage() {
            return this.isMounted ? this.$refs.table.currentx : 0
        },
        queriedItems() {
            return this.$refs.table ? this.$refs.table.queriedResults.length : this.teams.length
        },
        isAutologin() {
            return this.$store.state.isTeamAutologin
        }
    },
    methods: {
        copy(data) {
            copy(data)

            this.$vs.notify({
                title: 'Success!',
                text: this.$t('notification.success'),
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },
        resultFilter(data) {
            this.teamsListFilter = data
        },

        updateFilterFields() {
            this.$refs.table.closeExpands()
        },

        async getGroupByAdvertiser() {
            this.groupByAdvertiser = await send(this.$url.advrtsr_team_integration.group_by_advertiser, 'GET')
                .then(data => this.sortByAlphabet(data.data.result.filter(item => item.advertiser_integrations.length), 'name'))

            const getTeams = data => {
                const teams = new Set()
                data.advertiser_integrations.map(advertiser_integration =>
                    advertiser_integration.advertiser_team_integration.map(team =>
                        teams.add(team.teams.name)))

                return Array.from(teams)
            }

            this.groupByAdvertiser.forEach(item => {
                item.teams = getTeams(item)
                item.teamsLength = item.teams.length
            })

            EventBus.$emit('updateTeams', this.groupByAdvertiser)
        },

        changeTeamStatus(e, tr) {
            e.preventDefault()
            this.currentIndex = tr.id
            this.loadingEl = e.target.parentNode
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t(tr.is_active ? 'confirm.deactivateTeam' : 'confirm.activateTeam'),
                accept: this.confirmStatus,
                acceptText: this.$t(tr.is_active ? 'buttons.Deactivate' : 'buttons.Activate'),
                cancelText: this.$t('global.Cancel')
            })
        },

        confirmStatus() {
            this.$vs.loading({
                background: 'rgba(255,255,255,0.75)',
                color: 'primary',
                container: this.loadingEl,
                scale: +'0.45'
            })
            const dispatchPath = 'destroy',
                dispatchData = {
                    url: this.$url.settings_team.destroy,
                    mutation: 'CHANGE_TEAM_STATUS',
                    data: {
                        id: this.currentIndex
                    },
                    ids: {
                        id: this.currentIndex,
                        arrId: this.currentArrIndex
                    }
                }
            this.$store.dispatch(dispatchPath, dispatchData)
                .then(() => {
                    this.$vs.loading.close(this.loadingEl)
                    this.loadingEl = this.currentIndex = null
                }).catch(err => {
                new ErrorHandler(err).send
            })
        },

        callPopup(type, name, data, width) {
            const settingsPopup = {
                type: type,
                name: name
            }
            if (data) settingsPopup[data.nameProperty] = data.data

            if (width && typeof width === 'boolean') {
                settingsPopup.full = width
            }

            if (width && typeof width === 'string') {
                settingsPopup.width = width
            }

            EventBus.$emit('emitPopupEvent', settingsPopup)
        },

        findTeamByIdParam() {
            const team = this.$route.query.team
            if (team) {
                this.$refs.table.searchInput = team.split('%').join(' ')
                this.$router.replace({'query': null})
            }
        },

        async get() {
            try {
                await this.$store.dispatch('fetch', {
                    url: this.$url.settings_team.get,
                    mutation: 'SET_TEAMS'
                }).then(res => res.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },
    },

    async created() {
        if (!this.isAutologin) {
            this.headNotGroup = this.headNotGroup.filter(item => item.value !== 'autologin')
        }

        await this.get()

        EventBus.$on('getTeamsInt', async () => {
            await this.get()

            EventBus.$emit('resetInt')
        })

        EventBus.$on('getGroupedTeamsByAdvertiser', async () => {
            await this.getGroupByAdvertiser()
        })

        EventBus.$on('getTeams', async () => {
            await this.get()
        })

        this.findTeamByIdParam()
    },
    async mounted() {
        this.isMounted = true
    },
    beforeDestroy() {
        EventBus.$off('getTeams')
        EventBus.$off('getTeamsInt')
        EventBus.$off('getGroupedTeamsByAdvertiser')
        this.$store.commit('CLEAR_TEAMS')
    }
}

</script>

<style lang="scss">
#data-list-team-view {
    .cteate-team__btn {
        span.vs-button-text {
            white-space: nowrap !important;
        }
    }

    .team_id {
        font-size: 21px;
        font-weight: bold;
        color: gray;
    }

    .bg-chip-transparent.vs-chip-success {
        color: #28C76F !important;
    }
}

</style>
